import { Placeholder } from 'reactstrap'

const COLUMNS = 6
const ROWS = 20

const SkeletonTable = () => {
    return (
        <>
            <thead>
                <tr>
                    {[...Array(COLUMNS)].map((_, i) => (
                        <th key={i} style={{ padding: '4px 6px', width: `${100 / COLUMNS}%` }}>
                            <Placeholder animation="glow">
                                <Placeholder xs={10} size="sm" />
                            </Placeholder>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody data-testid="skeleton-table">
                {[...Array(ROWS)].map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        {[...Array(COLUMNS)].map((_, colIndex) => (
                            <td key={colIndex} style={{ padding: '4px 6px' }}>
                                <Placeholder animation="glow">
                                    <Placeholder xs={10} size="sm" />
                                </Placeholder>
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </>
    )
}

export default SkeletonTable
